module.exports = __webpack_public_path__ + "static/media/snowfall.0087a44a.svg";